var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0708008,
    y: 0.5,
    width: 36.0407,
    height: 35.9993,
    rx: 6.00678,
    fill: "#D3317D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7786 8.42188C9.25638 8.42188 8.00732 9.67093 8.00732 11.1931V21.664C8.00732 23.1862 9.25638 24.4342 10.7786 24.4342H21.2445C22.7667 24.4342 24.0158 23.1862 24.0158 21.664V11.1931C24.0158 9.67093 22.7667 8.42188 21.2445 8.42188H10.7786Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2651 21.9709C25.1552 23.8919 23.4866 25.5361 21.5895 25.6868C18.7432 25.711 15.896 25.6944 13.0492 25.6963C12.571 25.6967 12.1595 26.0908 12.2498 26.5594C12.5097 27.907 13.4951 28.5762 14.8188 28.5762C18.6242 28.5801 21.9157 28.582 25.5259 28.5724C27.0618 28.5334 28.1713 27.0612 28.1713 25.5325C28.1674 22.1587 28.1789 18.7848 28.1717 15.411C28.1715 15.2935 28.1517 15.1053 28.1226 14.9916C27.7746 13.6286 27.0351 12.9266 26.132 12.6744C25.6729 12.5462 25.2769 12.9509 25.2777 13.4292C25.2808 15.259 25.2857 19.5505 25.2651 21.9709Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.1e88cac7b717768ce6b5c1dd628ae572.svg";
export { ForwardRef as ReactComponent };